<template>
  <div>
    <b-card>
      <h2 class="text-blue font-weight-bold mb-2">
        {{ $t("referral_program_settings") }}
      </h2>

      <div class="d-flex align-items-center mb-3">
        <label class="mb-0 mr-2" style="font-size: 16px;">
          {{ $t("referral_program_active_for") }}
        </label>

        <b-form-select
            v-model="selected"
            :options="options"
            class="mr-2"
            style="max-width: 200px;"
        />
      </div>

      <div class="d-flex justify-content-between mt-3">
        <b-button variant="secondary" @click="goBack">
          {{ $t("back") }}
        </b-button>
        <b-button variant="primary" type="button" @click="saveSetting">
          {{ $t("update") }}
        </b-button>
      </div>
    </b-card>
  </div>
</template>


<script>
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  data() {
    return {
      selected: 'none',
      options: [
        { value: 'none', text: this.$t('none') },
        { value: 'all', text: this.$t('all') },
        { value: 'buyers', text: this.$t('buyers') },
        { value: 'sellers', text: this.$t('sellers') },
        { value: 'partners', text: this.$t('partners') },
      ],
    }
  },

  mounted() {
    this.load();
  },

  methods: {
    async load() {
      const res = await this.$http.get('referral-program/referral-setting/get');
      this.selected = res.data.value || 'none';
    },

    async saveSetting() {
      await this.$http.post('referral-program/referral-setting/update', {
        value: this.selected,
      });

      this.$toast({
        component: ToastificationContent,
        props: {
          title: this.$t('updated_successfully'),
          icon: "SuccessIcon",
          variant: "success",
          autoHideDelay: 2000,
        },
      });
    },

    goBack() {
      this.$router.back();
    },
  }
}

</script>
